import React from 'react';
import { Calendar, ChevronRight } from 'lucide-react';

interface FutureDueDatesProps {
  nextDueDates: string[];
  className?: string;
  maxDates?: number;
}

const FutureDueDates: React.FC<FutureDueDatesProps> = ({
  nextDueDates,
  className = '',
  maxDates = 5
}) => {
  if (!nextDueDates || nextDueDates.length === 0) {
    return null;
  }

  const datesToShow = nextDueDates.slice(0, maxDates);
  const hasMore = nextDueDates.length > maxDates;

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = date.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    if (diffDays < 7) return `In ${diffDays} days`;
    
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    });
  };

  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg p-3 ${className}`}>
      <div className="flex items-center mb-2">
        <Calendar className="w-4 h-4 text-blue-600 mr-2" />
        <h4 className="text-sm font-medium text-blue-900">Upcoming Due Dates</h4>
      </div>
      
      <div className="space-y-1">
        {datesToShow.map((dateString, index) => (
          <div key={index} className="flex items-center text-sm">
            <ChevronRight className="w-3 h-3 text-blue-500 mr-1" />
            <span className="text-blue-700">
              {formatDate(dateString)}
            </span>
            <span className="text-blue-500 ml-2 text-xs">
              ({new Date(dateString).toLocaleDateString()})
            </span>
          </div>
        ))}
        
        {hasMore && (
          <div className="text-xs text-blue-600 mt-2 font-medium">
            +{nextDueDates.length - maxDates} more dates...
          </div>
        )}
      </div>
    </div>
  );
};

export { FutureDueDates };
export default FutureDueDates;
